import { styled } from 'linaria/react';

export const Container = styled.div`
  width: 100%;
  height: 100%;
  padding: 0 var(--space-400) var(--space-200) var(--space-400);

  @media (--only-mobile) {
    padding: 0;
  }
`;
